<template>
  <div v-if="containedArticles.length > 0">
    <h2>{{ t('shop.containedArticles') }}</h2>
    <ul class="contained">
      <li v-for="subArticle in containedArticles" :key="subArticle.article.id">
        {{ subArticle.count }} &times; {{ subArticle.article.name }}
      </li>
    </ul>
  </div>
</template>

<script>
  import { defineComponent } from 'vue'
  import { useStrings } from '@/composables/useStrings.ts'

  export default defineComponent({
    props: {
      containedArticles: {
        required: true,
      },
    },
    setup() {
      const { t } = useStrings()
      return { t }
    },
  })
</script>
<style lang="scss" scoped>
  .contained {
    margin: 0 0 $spacer30;
    padding: 0;
    list-style-position: inside;
    list-style: none;
  }
</style>
